export const CHANNEL_ICONS: Record<string, string> = {
  airbnb: 'airbnb',
  airbnb_official: 'airbnb',
  booking_dot_com: 'bdc',
  home_away: 'vrbo',
  google: 'google',
  uplisting: 'logo-v2',
};

export function channelIcon(channel?: string): string | undefined {
  return CHANNEL_ICONS[channel as string];
}
